import React, { Component } from "react";
import PropTypes from "prop-types";
import find from "lodash.find";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import Paper from "material-ui/Paper";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import { DivHeaderActions, DivTitle } from "./styled";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Toggle from "material-ui/Toggle";
import { SketchColorPicker } from "../../../components";
import { Counter } from "./components";
import DialogTemplate, { data } from "./components/bgTheme";

class Body extends Component {
  constructor(props) {
    super(props);
    const {
      backgroundColor,
      backgroundImage,
      width,
      fullheight
    } = props.data.values;
    let fh = fullheight;
    if (fullheight === undefined) {
      fh = true;
    }
    this.state = {
      expanded: true,
      image: this.checkImage(backgroundImage.url),
      idImage: backgroundImage.url,
      backgroundColor: backgroundColor,
      contentWidth: width.contentWidth,
      type: width.type,
      maxValueWidth: width.type === "px" ? 0 : 100,
      interval: width.type === "px" ? 50 : 1,
      fullheight: fh
    };
  }

  checkImage = id => {
    let image = "";
    let result = find(data, function(item) {
      return item.id === id;
    });
    if (result) {
      return result.bg;
    }
    return image;
  };

  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    let width = {
      type: this.state.type,
      contentWidth: this.state.contentWidth
    };
    newData.values.backgroundColor = this.state.backgroundColor;
    newData.values.backgroundImage.url = this.state.idImage;
    newData.values.width = width;
    newData.values.contentWidth = width.contentWidth + width.type;
    newData.values.fullheight = this.state.fullheight;
    this.props.onUpdateData(newData);
  };
  onUpdateColor = color => {
    this.setState({ backgroundColor: color });
  };
  onSetValue = (key, value) => {
    this.setState({ contentWidth: value });
  };
  onItemSelected = bgSelected => {
    this.setState({ image: this.checkImage(bgSelected), idImage: bgSelected });
  };
  onChangeType = (event, value) => {
    let width = 0;
    let content = this.state.contentWidth;
    let interval = 50;
    if (value === "%") {
      width = 100;
      content = 100;
      interval = 1;
    }
    this.setState({
      type: value,
      maxValueWidth: width,
      contentWidth: content,
      interval: interval
    });
  };
  onToggleFullheight = () => {
    this.setState({ fullheight: !this.state.fullheight });
  };
  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Body"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText expandable={true}>
              <Paper style={{ padding: 10, marginBottom: 10 }} zDepth={1}>
                <Toggle
                  label="Full Height"
                  style={{ marginTop: 10 }}
                  toggled={this.state.fullheight}
                  onToggle={this.onToggleFullheight}
                />
              </Paper>
              <Paper style={{ padding: 10 }} zDepth={1}>
                <SketchColorPicker
                  title={"Background"}
                  onUpdateColor={color => this.onUpdateColor(color)}
                  color={this.state.backgroundColor}
                />
              </Paper>
              <Paper style={{ padding: 10, marginBottom: 10 }} zDepth={1}>
                <DivTitle>Background Themes</DivTitle>
                <DialogTemplate
                  bgItem={this.state.image}
                  onItemSelected={item => {
                    this.onItemSelected(item);
                  }}
                />
              </Paper>
              <Paper style={{ padding: 10 }} zDepth={1}>
                <DivTitle>Container Width</DivTitle>
                <RadioButtonGroup
                  name="type"
                  valueSelected={this.state.type}
                  onChange={this.onChangeType}
                  style={styles.radioGroup}
                >
                  <RadioButton
                    value="%"
                    label="Percent"
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="px"
                    label="Pixel"
                    style={styles.radioButton}
                  />
                </RadioButtonGroup>
                <Counter
                  isDisabled={false}
                  onSetValue={value => this.onSetValue("Width", value)}
                  value={this.state.contentWidth}
                  interval={this.state.interval}
                  maxValue={this.state.maxValueWidth}
                />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  radioButton: {
    width: 100
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
    marginBottom: 10
  }
};

Body.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

Body.defaultProps = {
  data: {}
};
export default Body;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/Body.js